const Flip = () => {
	return (
		<svg
			version="1.1"
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			x="0px"
			y="0px"
			height="25px"
			width="25px"
			viewBox="0 0 80 80"
			enableBackground="new 0 0 80 80"
		>
			<path
				fill="#505050"
				d="M37.48,52.49l-7.12,7.12l5.03,5.04l7.12-7.12L37.48,52.49z M30.36,50.41l7.12,7.12l5.03-5.04l-7.12-7.12
	L30.36,50.41z M30.36,59.61c-1.39,1.39-1.39,3.65,0,5.04c1.39,1.39,3.64,1.39,5.03,0L30.36,59.61z M40,55.01l2.52,2.52
	c1.39-1.39,1.39-3.65,0-5.04L40,55.01z M35.4,45.37c-1.39-1.39-3.64-1.39-5.03,0c-1.39,1.39-1.39,3.65,0,5.04L35.4,45.37z"
			/>
			<path
				fill="#505050"
				d="M0.84,37.2c0,6.99,5.57,12.36,12.4,15.77c7.03,3.52,16.5,5.59,26.77,5.59v-7.12c-9.4,0-17.73-1.91-23.58-4.84
	c-6.06-3.03-8.46-6.56-8.46-9.4H0.84z M40,15.84c-10.26,0-19.73,2.08-26.77,5.59c-6.82,3.41-12.4,8.78-12.4,15.77h7.12
	c0-2.84,2.4-6.37,8.46-9.4c5.85-2.92,14.18-4.84,23.58-4.84V15.84z M79.16,37.2c0-6.99-5.57-12.36-12.4-15.77
	c-7.03-3.52-16.5-5.59-26.77-5.59v7.12c9.4,0,17.73,1.92,23.58,4.84c6.06,3.03,8.46,6.56,8.46,9.4H79.16z M55,57.01
	c6.62-1.45,12.48-3.87,16.77-7.08c4.26-3.19,7.39-7.52,7.39-12.72h-7.12c0,2.11-1.26,4.57-4.54,7.02
	c-3.25,2.43-8.07,4.52-14.02,5.82L55,57.01z M40,58.57c1.97,0,3.56-1.59,3.56-3.56c0-1.96-1.59-3.56-3.56-3.56V58.57z M53.48,50.05
	c-1.92,0.42-3.14,2.32-2.72,4.24c0.42,1.92,2.32,3.14,4.24,2.72L53.48,50.05z"
			/>
		</svg>
	);
};

export default Flip;
